import { render, staticRenderFns } from "./CmgMealBuilderPage.vue?vue&type=template&id=58c21971&scoped=true&lang=pug&"
import script from "./cmg-meal-builder-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-meal-builder-page.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c21971",
  null
  
)

export default component.exports